import { PricesFilter } from '@/react-pages/Prices/Filters/BaseFilter';
import type { IconGlyph } from '@sunwebgroup/ui-components';
import { BaseInput, tk, Icon } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 15px;
`;

const FilterIcon = styled(Icon)`
  margin-right: ${tk('spacing_2xs')};
`;

interface InputProps extends React.PropsWithChildren {
  label: string;
  placeholder?: string;
  formattedSelectedValues?: string;
  disabled?: boolean;
  icon: IconGlyph;
  toggle?: () => void;
}

export const Input = ({ label, disabled, icon, toggle, children }: InputProps) => {
  return (
    <PricesFilter.Root>
      <PricesFilter.Label>{label}</PricesFilter.Label>
      <PricesFilter.Control onClick={toggle} $isDisabled={disabled}>
        <BaseInput.Box tabIndex={0}>
          <ContentWrapper>
            <FilterIcon glyph={icon} size="sm" />
            {children}
            <Icon glyph="IconChevronDown" size="sm" />
          </ContentWrapper>
        </BaseInput.Box>
      </PricesFilter.Control>
    </PricesFilter.Root>
  );
};
